import { encodePublicPath } from "@/utils/encodePublicPath";

// Structured Data for Beatenberg Resort & Spa
export const businessStructuredData = {
  "@context": "https://schema.org",
  "@type": "Hotel",
  "name": "Beatenberg Resort & Spa",
  "description": "Discover Switzerland's purest wellness sanctuary. 15-acre lakefront luxury resort in Beatenberg with panoramic Alpine views, NutraSwiss spa programs, and authentic Swiss hospitality.",
  "url": "https://beatenberg-resortspa.ch",
  "logo": "https://beatenberg-resortspa.ch/images/phb-icon-180.png",
  "image": [
    "https://beatenberg-resortspa.ch/og-image.jpg",
    "https://beatenberg-resortspa.ch/images/hero-image.webp",
    "https://beatenberg-resortspa.ch/images/hotel-exterior.webp"
  ],
  "telephone": "+41 33 841 00 21",
  "email": "info@beatenberg-resortspa.ch",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Spirenwaldstrasse 351",
    "addressLocality": "Beatenberg",
    "addressRegion": "Bern",
    "postalCode": "3803",
    "addressCountry": "CH"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 46.6969,
    "longitude": 7.7944
  },
  "starRating": {
    "@type": "Rating",
    "ratingValue": "5",
    "bestRating": "5"
  },
  "amenityFeature": [
    {
      "@type": "LocationFeatureSpecification",
      "name": "Spa & Wellness Center",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification", 
      "name": "Restaurant",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Fitness Center",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Swimming Pool",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Free WiFi",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Parking",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Billiards Room",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Private Balconies",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Conference Facilities",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Business Center",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Room Service",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Laundry Service",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Concierge",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Bar & Lounge",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Terrace & Garden",
      "value": true
    }
  ],
  "checkinTime": "15:00",
  "checkoutTime": "11:00",
  "petsAllowed": false,
  "smokingAllowed": false,
  "priceRange": "CHF 180 - CHF 600",
  "paymentAccepted": ["Cash", "Credit Card", "Debit Card"],
  "currenciesAccepted": "CHF",
  "openingHours": "Mo-Su 00:00-23:59",
  // OTA listing URLs - Verified canonical URLs from each platform
  "sameAs": [
    "https://www.facebook.com/beatenbergresortspa",
    "https://www.instagram.com/beatenbergresortspa",
    "https://www.linkedin.com/company/beatenberg-resort-spa",
    "https://www.booking.com/hotel/ch/parkhotel-beatenberg-beatenberg.html",
    "https://www.tripadvisor.com/Hotel_Review-g199033-d1020295-Reviews-Beatenberg_Resort_and_Spa_in_Beatenberg_Interlaken-Beatenberg_Canton_of_Bern.html",
    "https://www.expedia.com/Beatenberg-Hotels-Beatenberg-Resort-Spa.h99344037.Hotel-Information",
    "https://www.agoda.com/parkhotel-beatenberg_11/hotel/all/beatenberg-ch.html",
    "https://www.makemytrip.com/hotels-international/switzerland/grindelwald-hotels/beatenberg_resort_spa-details.html",
    "https://www.trivago.com/en-US/oar/beatenberg-resort-and-spa?search=100-41396670",
    "https://www.interlaken.ch/en/hotel/parkhotel-beatenberg"
  ]
};

export const websiteStructuredData = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Beatenberg Resort & Spa",
  "url": "https://beatenberg-resortspa.ch",
  "description": "Official website of Beatenberg Resort & Spa - Swiss Alpine luxury resort with wellness spa and panoramic mountain views",
  "publisher": {
    "@type": "Organization",
    "name": "Beatenberg Resort & Spa",
    "logo": {
      "@type": "ImageObject",
      "url": "https://beatenberg-resortspa.ch/images/phb-icon-180.png"
    }
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://beatenberg-resortspa.ch/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

export const organizationStructuredData = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Beatenberg Resort & Spa",
  "url": "https://beatenberg-resortspa.ch",
  "logo": "https://beatenberg-resortspa.ch/images/phb-icon-180.png",
  "description": "Luxury Swiss Alpine resort offering wellness spa experiences, fine dining, and panoramic mountain views in Beatenberg, Switzerland.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Spirenwaldstrasse 351",
    "addressLocality": "Beatenberg", 
    "addressRegion": "Bern",
    "postalCode": "3803",
    "addressCountry": "CH"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+41 33 841 00 21",
    "email": "info@beatenberg-resortspa.ch",
    "contactType": "customer service",
    "availableLanguage": ["English", "German", "French"]
  },
  "sameAs": [
    "https://www.facebook.com/beatenbergresortspa",
    "https://www.instagram.com/beatenbergresortspa",
    "https://www.linkedin.com/company/beatenberg-resort-spa"
  ]
};

// Room-specific structured data
export const createRoomStructuredData = (room: any) => ({
  "@context": "https://schema.org",
  "@type": "HotelRoom",
  "name": room.name,
  "description": room.longDescription,
  "url": `https://beatenberg-resortspa.ch/accommodations/${room.slug}`,
  "image": room.images.map((img: any) => {
    const path = img.ibeSrc?.w1600 ?? encodePublicPath(img.url);
    return `https://beatenberg-resortspa.ch${path}`;
  }),
  "occupancy": {
    "@type": "QuantitativeValue",
    "maxValue": room.capacity.maxOccupancy
  },
  "floorSize": {
    "@type": "QuantitativeValue",
    "value": room.size.squareMeters,
    "unitCode": "MTK"
  },
  "amenityFeature": room.amenities.map((amenity: any) => ({
    "@type": "LocationFeatureSpecification",
    "name": amenity.name,
    "value": true
  })),
  "offers": {
    "@type": "Offer",
    "price": room.pricing.basePrice,
    "priceCurrency": room.pricing.currency,
    "availability": room.available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
    "validFrom": "2025-01-01",
    "validThrough": "2026-12-31"
  }
});

// Spa service structured data
export const spaStructuredData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Wellness & Spa Services",
  "description": "Comprehensive wellness and spa services including NutraSwiss programs, Alpine-inspired treatments, and luxury spa facilities.",
  "provider": {
    "@type": "Organization",
    "name": "Beatenberg Resort & Spa",
    "url": "https://beatenberg-resortspa.ch"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Switzerland"
  },
  "serviceType": "Wellness and Spa Services",
  "offers": {
    "@type": "Offer",
    "description": "Luxury spa treatments and wellness programs",
    "priceRange": "CHF 50 - CHF 500"
  }
};

// Accommodations page structured data
export const accommodationsStructuredData = {
  "@context": "https://schema.org",
  "@type": "CollectionPage",
  "name": "Rooms & Suites - Beatenberg Resort & Spa",
  "description": "Discover our luxury rooms and suites at Beatenberg Resort & Spa. From cozy single rooms to spacious family suites, all with stunning Alpine views and Swiss comfort.",
  "url": "https://beatenberg-resortspa.ch/accommodations",
  "mainEntity": {
    "@type": "ItemList",
    "name": "Hotel Rooms and Suites",
    "description": "Luxury accommodations with Alpine views",
    "numberOfItems": 5,
    "itemListElement": [
      {
        "@type": "HotelRoom",
        "name": "Family Suite",
        "description": "Spacious accommodation perfect for families, featuring separate bedrooms and stunning Alpine views.",
        "url": "https://beatenberg-resortspa.ch/accommodations/family-suite",
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 6
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 65,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Private Balcony",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Kitchenette",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Ensuite Espresso Machine",
            "value": true
          }
        ]
      },
      {
        "@type": "HotelRoom",
        "name": "Junior Suite",
        "description": "Luxurious junior suite offering spacious living areas and premium Alpine comfort.",
        "url": "https://beatenberg-resortspa.ch/accommodations/junior-suite",
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 4
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 50,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Private Balcony",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Kitchenette",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Ensuite Espresso Machine",
            "value": true
          }
        ]
      },
      {
        "@type": "HotelRoom",
        "name": "Triple Room",
        "description": "Spacious triple accommodation perfect for small groups, featuring comfortable bedding and Alpine charm.",
        "url": "https://beatenberg-resortspa.ch/accommodations/triple-room",
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 4
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 30,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Family Amenities",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Mountain or Lake View",
            "value": true
          }
        ]
      },
      {
        "@type": "HotelRoom",
        "name": "Double Room",
        "description": "Sophisticated double room with modern amenities and panoramic Alpine vistas.",
        "url": "https://beatenberg-resortspa.ch/accommodations/double-room",
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 2
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 25,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Couple Amenities",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Mountain or Lake View",
            "value": true
          }
        ]
      },
      {
        "@type": "HotelRoom",
        "name": "Single Room",
        "description": "Cozy and comfortable single accommodation with Alpine-inspired wooden decor and modern amenities.",
        "url": "https://beatenberg-resortspa.ch/accommodations/single-room",
        "occupancy": {
          "@type": "QuantitativeValue",
          "maxValue": 1
        },
        "floorSize": {
          "@type": "QuantitativeValue",
          "value": 20,
          "unitCode": "MTK"
        },
        "amenityFeature": [
          {
            "@type": "LocationFeatureSpecification",
            "name": "Solo Traveler Amenities",
            "value": true
          },
          {
            "@type": "LocationFeatureSpecification",
            "name": "Mountain or Lake View",
            "value": true
          }
        ]
      }
    ]
  }
};

// Restaurant structured data
export const restaurantStructuredData = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  "name": "Restaurant Jungfrau - Beatenberg Resort & Spa",
  "description": "Authentic Swiss and international cuisine with panoramic Alpine views. Experience farm-to-table dining featuring local ingredients and traditional Swiss specialties.",
  "image": [
    "https://beatenberg-resortspa.ch/images/main_restaurant.png",
    "https://beatenberg-resortspa.ch/images/alpine_terrace.jpg",
    "https://beatenberg-resortspa.ch/images/breakfast_buffet.jpg"
  ],
  "url": "https://beatenberg-resortspa.ch/dining",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Spirenwaldstrasse 351",
    "addressLocality": "Beatenberg",
    "addressRegion": "Bern",
    "postalCode": "3803",
    "addressCountry": "CH"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 46.6969,
    "longitude": 7.7944
  },
  "telephone": "+41 33 841 00 21",
  "email": "info@beatenberg-resortspa.ch",
  "servesCuisine": ["Swiss", "International", "European", "Alpine Cuisine"],
  "priceRange": "CHF 30-80",
  "acceptsReservations": true,
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      "opens": "07:00",
      "closes": "22:00"
    }
  ],
  "hasMenu": {
    "@type": "Menu",
    "name": "Five-Course Tasting Menu",
    "description": "Chef's seasonal selection showcasing Swiss Alpine ingredients and traditional recipes with a modern twist",
    "url": "https://beatenberg-resortspa.ch/dining"
  },
  "amenityFeature": [
    {
      "@type": "LocationFeatureSpecification",
      "name": "Outdoor Seating",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Mountain Views",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Private Dining Rooms",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Vegetarian Options",
      "value": true
    }
  ]
};

// Events venue structured data
export const eventsVenueStructuredData = {
  "@context": "https://schema.org",
  "@type": "EventVenue",
  "name": "Beatenberg Resort & Spa - Event & Wedding Venue",
  "description": "Luxury event venue for weddings, corporate events, and private celebrations with panoramic Alpine views. Comprehensive planning services and elegant event spaces.",
  "url": "https://beatenberg-resortspa.ch/events",
  "image": [
    "https://beatenberg-resortspa.ch/images/events/wedding.webp",
    "https://beatenberg-resortspa.ch/images/events/corporate.webp",
    "https://beatenberg-resortspa.ch/images/events/celebrations.webp"
  ],
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Beatenberg",
    "addressLocality": "Beatenberg",
    "addressRegion": "Bern",
    "postalCode": "3803",
    "addressCountry": "CH"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 46.6969,
    "longitude": 7.7944
  },
  "telephone": "+41 33 841 00 21",
  "maximumAttendeeCapacity": 200,
  "amenityFeature": [
    {
      "@type": "LocationFeatureSpecification",
      "name": "Wedding Planning Services",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Catering Services",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Audio/Visual Equipment",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Mountain View Terrace",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Indoor Event Spaces",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Accommodations On-Site",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Free WiFi",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Parking",
      "value": true
    }
  ]
};

// Event planning service structured data
export const eventPlanningServiceStructuredData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Wedding Planning & Event Coordination",
  "name": "Event Planning Services",
  "description": "Comprehensive wedding planning, corporate event coordination, and private celebration services in the Swiss Alps.",
  "provider": {
    "@type": "Organization",
    "name": "Beatenberg Resort & Spa",
    "url": "https://beatenberg-resortspa.ch"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Switzerland"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Event Services",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Wedding Ceremonies & Receptions",
          "description": "Complete wedding planning and coordination services with breathtaking Alpine backdrop"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Corporate Events",
          "description": "Business meetings, conferences, team building, and corporate retreats"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Private Celebrations",
          "description": "Birthdays, anniversaries, family reunions, and special occasions"
        }
      }
    ]
  }
};

// Enhanced spa structured data
export const enhancedSpaStructuredData = {
  "@context": "https://schema.org",
  "@type": "DaySpa",
  "name": "Beatenberg Wellness & Spa",
  "description": "Luxury spa featuring NutraSwiss wellness programs, Alpine-inspired treatments, and comprehensive spa facilities with panoramic mountain views.",
  "url": "https://beatenberg-resortspa.ch/spa",
  "image": [
    "https://beatenberg-resortspa.ch/images/spa/spa-exterior.webp",
    "https://beatenberg-resortspa.ch/images/spa/spa-pool.webp",
    "https://beatenberg-resortspa.ch/images/spa/treatment-room.webp"
  ],
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Beatenberg",
    "addressLocality": "Beatenberg",
    "addressRegion": "Bern",
    "postalCode": "3803",
    "addressCountry": "CH"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": 46.6969,
    "longitude": 7.7944
  },
  "telephone": "+41 33 841 00 21",
  "email": "spa@beatenberg-resortspa.ch",
  "priceRange": "CHF 80-350",
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Spa Services & Treatments",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Alpine Stone Therapy",
          "description": "Hot stone massage using heated Alpine minerals and essential oils"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "NutraSwiss Wellness Programs",
          "description": "Comprehensive 3-7 day wellness programs by NutraSwiss experts"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Mountain Herb Facial",
          "description": "Rejuvenating facial treatment using Swiss Alpine botanicals"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Swiss Chocolate Body Wrap",
          "description": "Indulgent body treatment with premium Swiss chocolate"
        }
      }
    ]
  },
  "amenityFeature": [
    {
      "@type": "LocationFeatureSpecification",
      "name": "Finnish Sauna",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Steam Room",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Indoor Pool",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Relaxation Lounge",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Mountain View Treatment Rooms",
      "value": true
    },
    {
      "@type": "LocationFeatureSpecification",
      "name": "Couples Treatment Rooms",
      "value": true
    }
  ]
};

// Local attractions structured data
export const attractionsStructuredData = {
  "@context": "https://schema.org",
  "@type": "TouristDestination",
  "name": "Beatenberg & Bernese Oberland Attractions",
  "description": "Discover world-famous Swiss Alpine attractions, activities, and experiences from Beatenberg Resort & Spa. Easy access to Jungfraujoch, Interlaken, and premier hiking trails.",
  "url": "https://beatenberg-resortspa.ch/local-attractions",
  "includesAttraction": [
    {
      "@type": "TouristAttraction",
      "name": "Jungfraujoch - Top of Europe",
      "description": "UNESCO World Heritage site at 3,454m altitude with observation deck, Ice Palace, and Sphinx Observatory",
      "image": "https://beatenberg-resortspa.ch/images/attractions/jungfraujoch.webp",
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 46.5475,
        "longitude": 7.9850
      },
      "touristType": ["Nature Lovers", "Adventure Seekers", "Photographers", "Families"]
    },
    {
      "@type": "TouristAttraction",
      "name": "Interlaken",
      "description": "Gateway to the Swiss Alps with adventure sports, shopping, and lakeside promenades between Lake Thun and Lake Brienz",
      "image": "https://beatenberg-resortspa.ch/images/attractions/interlaken.webp",
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 46.6863,
        "longitude": 7.8632
      },
      "touristType": ["Adventure Seekers", "Shoppers", "Families"]
    },
    {
      "@type": "TouristAttraction",
      "name": "Lake Thun",
      "description": "Crystal-clear Alpine lake with boat cruises, water sports, and scenic lakeside villages",
      "image": "https://beatenberg-resortspa.ch/images/attractions/lake-thun.webp",
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 46.7433,
        "longitude": 7.6287
      },
      "touristType": ["Nature Lovers", "Families", "Water Sports Enthusiasts"]
    },
    {
      "@type": "TouristAttraction",
      "name": "Niederhorn Mountain",
      "description": "Accessible mountain peak with panoramic 360-degree views of the Alps and Lake Thun",
      "image": "https://beatenberg-resortspa.ch/images/attractions/niederhorn.webp",
      "touristType": ["Hikers", "Nature Lovers", "Photographers"]
    }
  ]
};

// Seasonal activities structured data
export const seasonalActivitiesStructuredData = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  "name": "Seasonal Activities in Beatenberg",
  "description": "Year-round activities and experiences near Beatenberg Resort & Spa",
  "url": "https://beatenberg-resortspa.ch/local-attractions",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "item": {
        "@type": "Thing",
        "name": "Summer Alpine Hiking",
        "description": "300km of marked Alpine hiking trails with varying difficulty levels"
      }
    },
    {
      "@type": "ListItem",
      "position": 2,
      "item": {
        "@type": "Thing",
        "name": "Winter Skiing & Snowboarding",
        "description": "Access to 200km of ski slopes in Grindelwald and Interlaken ski regions"
      }
    },
    {
      "@type": "ListItem",
      "position": 3,
      "item": {
        "@type": "Thing",
        "name": "Spring Mountain Biking",
        "description": "Scenic mountain bike trails through Alpine meadows and forests"
      }
    },
    {
      "@type": "ListItem",
      "position": 4,
      "item": {
        "@type": "Thing",
        "name": "Autumn Photography Tours",
        "description": "Capture stunning fall foliage against Alpine peaks"
      }
    }
  ]
};

// Video schema for hero videos
export const createVideoSchema = (videoData: {
  name: string;
  description: string;
  videoUrl: string;
  thumbnailUrl?: string;
  uploadDate: string;
  duration?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "VideoObject",
  "name": videoData.name,
  "description": videoData.description,
  "contentUrl": videoData.videoUrl,
  "uploadDate": videoData.uploadDate,
  ...(videoData.thumbnailUrl && { "thumbnailUrl": videoData.thumbnailUrl }),
  ...(videoData.duration && { "duration": videoData.duration }),
  "publisher": {
    "@type": "Organization",
    "name": "Beatenberg Resort & Spa",
    "logo": {
      "@type": "ImageObject",
      "url": "https://beatenberg-resortspa.ch/images/phb-icon-180.png"
    }
  }
});

// Breadcrumb schema generator
export const createBreadcrumbSchema = (items: Array<{ name: string; url: string }>) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

// FAQ schema generator for pages
export const createFAQSchema = (faqs: Array<{ question: string; answer: string }>) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

// Aggregate rating schema (ready for when reviews are available)
export const createAggregateRatingSchema = (ratingData: {
  ratingValue: number;
  reviewCount: number;
  bestRating?: number;
  worstRating?: number;
}) => ({
  "@context": "https://schema.org",
  "@type": "AggregateRating",
  "ratingValue": ratingData.ratingValue,
  "reviewCount": ratingData.reviewCount,
  "bestRating": ratingData.bestRating || 5,
  "worstRating": ratingData.worstRating || 1,
  "itemReviewed": {
    "@type": "Hotel",
    "name": "Beatenberg Resort & Spa",
    "url": "https://beatenberg-resortspa.ch"
  }
});

// Review schema (ready for when individual reviews are available)
export const createReviewSchema = (reviewData: {
  author: string;
  datePublished: string;
  reviewRating: number;
  reviewBody: string;
  reviewTitle?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Review",
  "author": {
    "@type": "Person",
    "name": reviewData.author
  },
  "datePublished": reviewData.datePublished,
  "reviewRating": {
    "@type": "Rating",
    "ratingValue": reviewData.reviewRating,
    "bestRating": 5
  },
  "reviewBody": reviewData.reviewBody,
  ...(reviewData.reviewTitle && { "name": reviewData.reviewTitle }),
  "itemReviewed": {
    "@type": "Hotel",
    "name": "Beatenberg Resort & Spa",
    "url": "https://beatenberg-resortspa.ch"
  }
});

// Common FAQs for Spa page
export const spaFAQSchema = createFAQSchema([
  {
    question: "What is included in the NutraSwiss wellness programs?",
    answer: "Our NutraSwiss wellness programs include personalized health assessments, customized treatment plans, nutritional guidance, spa treatments, fitness sessions, and comprehensive wellness consultations. Programs range from 3-7 days and are tailored to your specific health and wellness goals."
  },
  {
    question: "Do I need to book spa treatments in advance?",
    answer: "Yes, we highly recommend booking spa treatments in advance to ensure availability, especially during peak seasons. You can book treatments when making your room reservation or contact our spa concierge directly."
  },
  {
    question: "What are the spa facility hours?",
    answer: "Our spa facilities including the sauna, steam room, and relaxation areas are open daily from 7:00 AM to 10:00 PM. Treatment sessions are available from 9:00 AM to 8:00 PM. Please check with the spa reception for specific treatment availability."
  },
  {
    question: "Are spa facilities included with room booking?",
    answer: "Yes, all hotel guests have complimentary access to our spa facilities including the indoor pool, sauna, steam room, and relaxation lounge. Individual treatments and wellness programs are available at additional cost."
  }
]);

// Common FAQs for Events page
export const eventsFAQSchema = createFAQSchema([
  {
    question: "What is the maximum capacity for weddings and events?",
    answer: "Our event venues can accommodate up to 200 guests for weddings and special events. We offer both indoor and outdoor spaces with stunning Alpine views, and our team can help configure the space to suit your specific needs."
  },
  {
    question: "Do you provide wedding planning services?",
    answer: "Yes, we offer comprehensive wedding planning services including venue setup, catering coordination, accommodation arrangements for guests, audiovisual equipment, and on-site coordination. Our experienced event team will work with you to create your perfect Alpine wedding."
  },
  {
    question: "Can you accommodate corporate events and meetings?",
    answer: "Absolutely. We specialize in corporate events, business meetings, conferences, and team-building retreats. Our facilities include modern audiovisual equipment, high-speed WiFi, flexible meeting spaces, and professional catering services."
  },
  {
    question: "What catering options are available for events?",
    answer: "We offer customizable catering menus featuring Swiss and international cuisine, prepared by our experienced culinary team. Options include seated dinners, buffet service, cocktail receptions, and traditional Swiss specialties. We can accommodate dietary restrictions and preferences."
  }
]);

// Common FAQs for Accommodations page
export const accommodationsFAQSchema = createFAQSchema([
  {
    question: "What is your check-in and check-out time?",
    answer: "Check-in time is 3:00 PM (15:00) and check-out time is 11:00 AM. Early check-in and late check-out may be available upon request, subject to availability and additional charges."
  },
  {
    question: "Are pets allowed at the resort?",
    answer: "No, pets are not allowed at the resort."
  },
  {
    question: "Do all rooms have mountain or lake views?",
    answer: "Most of our rooms and suites feature stunning views of either the Alpine mountains or Lake Thun. Specific view preferences can be requested at the time of booking, subject to availability."
  },
  {
    question: "What amenities are included in the rooms?",
    answer: "All rooms include free WiFi, flat-screen TV, minibar, premium bedding, ensuite bathroom with luxury toiletries, and mountain or lake views. Suites also feature private balconies, kitchenettes, and espresso machines. Access to spa facilities is complimentary for all guests."
  }
]);
